import { render, staticRenderFns } from "./ArchiveCard.vue?vue&type=template&id=8f0bb608&scoped=true"
import script from "./ArchiveCard.vue?vue&type=script&lang=js"
export * from "./ArchiveCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0bb608",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f0bb608')) {
      api.createRecord('8f0bb608', component.options)
    } else {
      api.reload('8f0bb608', component.options)
    }
    module.hot.accept("./ArchiveCard.vue?vue&type=template&id=8f0bb608&scoped=true", function () {
      api.rerender('8f0bb608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/cardHandling/components/ArchiveCard.vue"
export default component.exports